import React, { createContext, useContext, useEffect, useState } from 'react';
import isEmpty from 'lodash/isEmpty';

// oxlint-disable-next-line no-restricted-imports -- TODO WEBTECH-1501: Replace old schema object types with operation-specific types.

import { createSearchVariablesFromContextData } from './searchContextUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const SearchContext = /*#__PURE__*/createContext(null);
const SearchProvider = ({
  children,
  searchData
}) => {
  const [currentSearchData, setCurrentSearchData] = useState(searchData);
  const [isSearchComplete, setIsSearchComplete] = useState(false);
  const [isSearchFormOpen, setIsSearchFormOpen] = useState(false);
  const searchVariables = createSearchVariablesFromContextData(currentSearchData);
  useEffect(() => {
    sessionStorage.setItem('currentSearchData', JSON.stringify(currentSearchData));
  }, [currentSearchData]);
  const setSearchData = value => {
    setCurrentSearchData(state => ({
      ...state,
      ...value
    }));
  };
  const values = {
    currentSearchData,
    isSearchComplete,
    isSearchFormOpen,
    searchVariables,
    setIsSearchComplete,
    setIsSearchFormOpen,
    setSearchData
  };
  return /*#__PURE__*/_jsx(SearchContext.Provider, {
    value: values,
    children: children
  });
};
const useSearch = () => {
  const context = useContext(SearchContext);
  if (isEmpty(context)) {
    throw new Error('useSearch must be used within a SearchContextProvider');
  }
  return context;
};
export { SearchProvider, useSearch };
//# sourceMappingURL=SearchContext.js.map